// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IjxDZ","logo":"styles_logo__EHotQ","illus":"styles_illus__bQdjD","btn":"styles_btn__cR8ow"};